// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class YTMRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_YTM_REQUEST, fieldSet);
    }
    setRequestId(id) {
        this.setFieldValue(FieldsFactory.FIELD_REQUEST_ID, id);
    }
    setInstrumentId(instrumentId) {
        this.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, instrumentId);
    }
    setRouteId(routeId) {
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
    }
}
